(() => {
  const target = document.querySelector('.product-details > form .cta-buttons');
  const ctaBtn  = document.querySelector('.product-details > form .cta-buttons'); // change this to the element you want to add class on
  if (!target || !ctaBtn) return;

  const ACTIVE_CLASS = 'cta-out-of-view';

  const io = new IntersectionObserver(
    ([entry]) => {
      const method = entry.isIntersecting ? 'remove' : 'add';
      ctaBtn.classList[method](ACTIVE_CLASS);
    },
    { threshold: 0.01, rootMargin: '0px' }
  );

  io.observe(target);
})();


document.addEventListener('DOMContentLoaded', function() {

class UpsellCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Swiper(this, {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: this.querySelector(".cart-upsell-next"),
        prevEl: this.querySelector(".cart-upsell-prev"),
      },
    });
  }
}

customElements.define('upsell-cart', UpsellCart);


document.addEventListener("DOMContentLoaded", function() {
  CartDrop(true);
});



    class JciUpsellSwiper extends HTMLElement {
      connectedCallback() {
        if (typeof Swiper === 'undefined') return;
        new Swiper(this, {
          slidesPerView: 2,
          spaceBetween: 16,
          loop: true,
          navigation: {
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
          breakpoints: {
            768: {
              slidesPerView: 4,
              spaceBetween: 24,
            }
          }
        });
      }
    }

    if (!customElements.get('jci-upsell-swiper')) {
      customElements.define('jci-upsell-swiper', JciUpsellSwiper);
    }
  });